import React from "react";
import ReactApexChart from "react-apexcharts";

// agar dono positive arrays alag-alag sources hain to true rakho,
// agar `_new` already purana data include karta hai to false rakho
const SUM_POSITIVE_SOURCES = false;

const UnitCountFive = ({
  total_reviews_positive_loop = [],
  total_reviews_positive_loop_new = [],
  total_reviews_negative_loop = [],
}) => {
  // month -> count map
  const toMap = (arr) => {
    const m = new Map();
    arr.forEach((it) => {
      const key = it?.month_name;
      if (!key) return;
      const val = parseInt(it.total_count, 10) || 0;
      m.set(key, (m.get(key) || 0) + val);
    });
    return m;
  };

  const posOldMap = toMap(total_reviews_positive_loop);
  const posNewMap = toMap(total_reviews_positive_loop_new);
  const negMap = toMap(total_reviews_negative_loop);

  // positive final map
  const posMap = new Map();
  const posKeys = new Set([...posOldMap.keys(), ...posNewMap.keys()]);
  posKeys.forEach((k) => {
    const oldV = posOldMap.get(k) || 0;
    const newV = posNewMap.get(k) || 0;
    posMap.set(k, SUM_POSITIVE_SOURCES ? oldV + newV : Math.max(oldV, newV));
  });

  // months ka union, original order preserve karte hue
  const months = [];
  [
    total_reviews_positive_loop,
    total_reviews_positive_loop_new,
    total_reviews_negative_loop,
  ].forEach((arr) =>
    arr.forEach((it) => {
      if (it?.month_name && !months.includes(it.month_name)) {
        months.push(it.month_name);
      }
    }),
  );

  // ab dono series same length + same order
  const totalPositiveArray = months.map((m) => posMap.get(m) || 0);
  const totalnegativeArray = months.map((m) => negMap.get(m) || 0);
  const totalmonth_name = months;

  const sum = (a) => a.reduce((acc, v) => acc + v, 0);
  const totalPositive_sum = sum(totalPositiveArray);
  const totalNegative_sum = sum(totalnegativeArray);

  let createChartSix = (color1, color2) => {
    let series = [
      { name: "Negative Reviews", data: totalnegativeArray },
      { name: "Positive Reviews", data: totalPositiveArray },
    ];
    let options = {
      legend: { show: false },
      chart: {
        type: "area",
        width: "100%",
        height: 270,
        toolbar: { show: false },
      },
      dataLabels: { enabled: false },
      stroke: {
        curve: "smooth",
        width: 2,
        colors: [color1, color2],
        lineCap: "round",
      },
      grid: {
        show: true,
        borderColor: "#D1D5DB",
        strokeDashArray: 1,
        position: "back",
        xaxis: { lines: { show: false } },
        yaxis: { lines: { show: false } },
        padding: { top: -20, right: 0, bottom: -10, left: 0 },
      },
      fill: {
        type: "gradient",
        colors: [color1, color2],
        gradient: {
          shade: "light",
          type: "vertical",
          shadeIntensity: 0.5,
          gradientToColors: [undefined, `${color2}00`],
          inverseColors: false,
          opacityFrom: [0.4, 0.4],
          opacityTo: [0.3, 0.3],
          stops: [0, 100],
        },
      },
      markers: {
        colors: [color1, color2],
        strokeWidth: 2,
        size: 0,
        hover: { size: 7 },
      },
      xaxis: {
        categories: totalmonth_name,
        tooltip: { enabled: false },
        labels: {
          formatter: (value) => value,
          style: { fontSize: "14px" },
        },
      },
      yaxis: {
        labels: {
          formatter: (value) => "" + value + "\u00A0",
          style: { fontSize: "14px" },
        },
      },
      tooltip: { x: { format: "dd/MM/yy HH:mm" } },
    };

    return (
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={270}
      />
    );
  };

  return (
    <div className="col-xxl-8">
      <div className="card radius-8 border-0 p-20">
        <div className="">
          <div className="card-body p-0">
            <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
              <h6 className="mb-2 fw-bold text-lg">Overview</h6>
            </div>
            <ul className="d-flex flex-wrap align-items-center justify-content-center mt-3 gap-3">
              <li className="d-flex align-items-center gap-2">
                <span className="w-12-px h-12-px rounded-circle bg-negative-600" />
                <span className="text-secondary-light text-sm fw-semibold">
                  Negative:&nbsp;
                  <span className="text-primary-light fw-bold">
                    {totalNegative_sum}
                  </span>
                </span>
              </li>
              <li className="d-flex align-items-center gap-2">
                <span className="w-12-px h-12-px rounded-circle bg-success-main" />
                <span className="text-secondary-light text-sm fw-semibold">
                  Positive:&nbsp;
                  <span className="text-primary-light fw-bold">
                    {totalPositive_sum}
                  </span>
                </span>
              </li>
            </ul>
            <div className="mt-40">
              <div id="enrollmentChart" className="apexcharts-tooltip-style-1">
                {createChartSix("#487fff", "#45B369")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitCountFive;
